import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, SHAPES } from '../gameData';

export default class RoverArea extends RegionArea
{
    /**
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[parentRegion.region].ROVER);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.backWindowLeft.setAlpha(0);
        this.backWindowRight.setAlpha(0);
        this.roof.setAlpha(0);
        this.sideWindow.setAlpha(0);
        this.frontTire.setAlpha(0);
        this.middleTire.setAlpha(0);
        this.backTire.setAlpha(0);
        this.frontTireHub.setAlpha(0);
        this.middleTireHub.setAlpha(0);
        this.backTireHub.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.backWindowLeft.disableInteractive();
        this.backWindowRight.disableInteractive();
        this.roof.disableInteractive();
        this.sideWindow.disableInteractive();
        this.frontTire.disableInteractive();
        this.middleTire.disableInteractive();
        this.backTire.disableInteractive();
        this.frontTireHub.disableInteractive();
        this.middleTireHub.disableInteractive();
        this.backTireHub.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.backWindowLeft.setAlpha(0.000001);
        this.backWindowRight.setAlpha(0.000001);
        this.roof.setAlpha(0.000001);
        this.sideWindow.setAlpha(0.000001);
        this.frontTire.setAlpha(0.000001);
        this.middleTire.setAlpha(0.000001);
        this.backTire.setAlpha(0.000001);
        this.frontTireHub.setAlpha(0.000001);
        this.middleTireHub.setAlpha(0.000001);
        this.backTireHub.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let backWindowHitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 79 },
                { x: 0, y: 28 },
                { x: 53, y: 0 },
                { x: 53, y: 51 },
            ]);
        this.backWindowLeft = ABCya.Images.addImage(824, 454, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_BkWndw, this.parentRegion).setInteractive(backWindowHitArea, Phaser.Geom.Polygon.Contains);
        this.backWindowLeft.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.backWindowLeft, SHAPES.SQUARE);
        });

        this.backWindowRight = ABCya.Images.addImage(892, 415, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_BkWndw, this.parentRegion).setInteractive(backWindowHitArea, Phaser.Geom.Polygon.Contains);
        this.backWindowRight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.backWindowRight, SHAPES.SQUARE);
        });

        let roofHitArea = new Phaser.Geom.Polygon(
            [
                { x: 289, y: 255 },
                { x: 0, y: 86 },
                { x: 149, y: 0 },
                { x: 439, y: 163 },
            ]);
        this.roof = ABCya.Images.addImage(715, 293, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_Rf, this.parentRegion).setInteractive(roofHitArea, Phaser.Geom.Polygon.Contains);
        this.roof.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.roof, SHAPES.RECTANGLE);
        });

        let sideWindowHitArea = new Phaser.Geom.Polygon(
            [
                { x: 248, y: 192 },
                { x: 0, y: 51 },
                { x: 0, y: 0 },
                { x: 248, y: 142 },
            ]);
        this.sideWindow = ABCya.Images.addImage(639, 387, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_SdWndw, this.parentRegion).setInteractive(sideWindowHitArea, Phaser.Geom.Polygon.Contains);
        this.sideWindow.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.sideWindow, SHAPES.RECTANGLE);
        });

        let tireHitArea = new Phaser.Geom.Polygon(
            [
                { x: 77, y: 146 },
                { x: 35, y: 125 },
                { x: 5, y: 83 },
                { x: 3, y: 40 },
                { x: 61, y: 0 },
                { x: 88, y: 5 },
                { x: 121, y: 32 },
                { x: 146, y: 80 },
                { x: 140, y: 113 },
                { x: 95, y: 139 },
            ]);
        this.frontTire = ABCya.Images.addImage(470, 416, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_Tire, this.parentRegion).setInteractive(tireHitArea, Phaser.Geom.Polygon.Contains);
        this.frontTire.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.frontTire, SHAPES.CYLINDER);
        });

        this.middleTire = ABCya.Images.addImage(581, 479, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_Tire, this.parentRegion).setInteractive(tireHitArea, Phaser.Geom.Polygon.Contains);
        this.middleTire.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.middleTire, SHAPES.CYLINDER);
        });

        this.backTire = ABCya.Images.addImage(690, 543, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_Tire, this.parentRegion).setInteractive(tireHitArea, Phaser.Geom.Polygon.Contains);
        this.backTire.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.backTire, SHAPES.CYLINDER);
        });

        let tirehubHitArea = new Phaser.Geom.Polygon(
            [
                { x: 42, y: 65 },
                { x: 24, y: 58 },
                { x: 8, y: 41 },
                { x: 1, y: 14 },
                { x: 12, y: 1 },
                { x: 37, y: 9 },
                { x: 52, y: 29 },
                { x: 57, y: 47 },
                { x: 53, y: 60 },
            ]);
        this.frontTireHub = ABCya.Images.addImage(450, 430, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_Hbcap, this.parentRegion).setInteractive(tirehubHitArea, Phaser.Geom.Polygon.Contains);
        this.frontTireHub.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.frontTireHub, SHAPES.CIRCLE);
        });

        this.middleTireHub = ABCya.Images.addImage(560, 494, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_Hbcap, this.parentRegion).setInteractive(tirehubHitArea, Phaser.Geom.Polygon.Contains);
        this.middleTireHub.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.middleTireHub, SHAPES.CIRCLE);
        });

        this.backTireHub = ABCya.Images.addImage(670, 556, UIAssetKeys._12_Space_Zoom_In_Rover_Slct_Hbcap, this.parentRegion).setInteractive(tirehubHitArea, Phaser.Geom.Polygon.Contains);
        this.backTireHub.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.backTireHub, SHAPES.CIRCLE);
        });

        this.shapeOverlays[SHAPES.RECTANGLE] = [this.roof, this.sideWindow];
        this.shapeOverlays[SHAPES.SQUARE] = [this.backWindowLeft, this.backWindowRight];
        this.shapeOverlays[SHAPES.CIRCLE] = [this.backTireHub, this.frontTireHub, this.middleTireHub];
        this.shapeOverlays[SHAPES.CYLINDER] = [this.frontTire, this.middleTire, this.backTire];

        this._createAreaInformation(0x5f5fd6, 0x67adb9);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.dome, this.parentRegion.greenhouse
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.roverContainer, duration: 1000, props: { scale: 2.2727, x: -546, y: -779 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.backWindowLeft.disableInteractive();
        this.backWindowRight.disableInteractive();
        this.roof.disableInteractive();
        this.sideWindow.disableInteractive();
        this.frontTire.disableInteractive();
        this.middleTire.disableInteractive();
        this.backTire.disableInteractive();
        this.frontTireHub.disableInteractive();
        this.middleTireHub.disableInteractive();
        this.backTireHub.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.roverContainer, duration: 1000, props: { scale: 1, x: this.parentRegion.roverContainer.onScreenPosition.x, y: this.parentRegion.roverContainer.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.greenhouse, this.parentRegion.dome], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}